// home/hooks/order-summary/useCartCalculations.ts
import { Productbtn } from "../../../../../../shared/services/interfacev2";
import { useMemo } from "react";

export const useCartCalculations = (
  selectedProductslist: Productbtn[],
  valueMap: { [id: string]: number },
  condition: number,
  deliveryFee: number,
  editedAmounts: { [productId: string]: string } = {}
) => {
  return useMemo(() => {
    let totalQuantity = 0;
    let totalAmount = 0;
    let disValue = 0;

    selectedProductslist.forEach((product) => {
      const key = `${product._id.$oid}-${product.amount}`;
      const quantity = valueMap[key] || 0;
      totalQuantity += quantity;
      
      // Use edited amount if available
      const productAmount = editedAmounts[product._id.$oid] || product.amount;
      totalAmount += quantity * parseFloat(productAmount);
    });

    // Calculate discount
    disValue = condition > totalAmount ? totalAmount : condition;

    const grandTotal = totalAmount - disValue + deliveryFee;

    return {
      totalQuantity,
      totalAmount,
      disValue,
      grandTotal,
    };
  }, [selectedProductslist, valueMap, condition, deliveryFee, editedAmounts]);
};